import { toIds } from '@clearverify/utils';

import { AccessRestrictionMode, InvitedPeoStaffData, PeoStaffRole } from 'src/api';

// Import the util directly (not via the barrel) so this stays importable in vitest
// without dragging the MUI component chain in.
import { convertEmployeeBlacklist } from '../../AccessRestrictionModeFormPart/utils/convertEmployeeBlacklist';
import { InviteFormFieldsValuesForStaff } from '../types';

export const convertStaff = (staff: InviteFormFieldsValuesForStaff[]): InvitedPeoStaffData[] => {
  return staff.map(staff => {
    const isPeoSuperAdmin = staff.businessRole === PeoStaffRole.PeoSuperAdmin;
    const isWhitelist = staff.accessRestrictionMode === AccessRestrictionMode.Whitelist;

    return {
      email: staff.email,
      role: staff.businessRole,

      ...(isPeoSuperAdmin
        ? undefined
        : {
            accessRestrictionMode: staff.accessRestrictionMode,
            // Send only the active mode's lists; clear the other mode's so we never persist
            // dangling entries the server would ignore.
            employeesBlacklistList: isWhitelist
              ? []
              : convertEmployeeBlacklist(staff.employeeBlacklist),
            employersBlacklistIdList: isWhitelist ? [] : toIds(staff.employerBlacklist),
            employersWhitelistIdList: isWhitelist ? toIds(staff.employerWhitelist) : [],
          }),
    } satisfies InvitedPeoStaffData;
  });
};
